<template>
<navBack></navBack>
    <div class="page">
      
        <div class="customerBox casherBox">
            <div class="title">结账客户</div>
            <div class="customerBar">
                <div class="left" v-if="customerType !== 1">
                    <div class="firstBar">{{ customer.name }} {{ customer.mobile }}</div>
                    <div class="secondBar">
                        <div class="someItem">本金<text class="bigFinger"> ¥{{ customer.storeAmount / 100 }}</text></div>
                        <div class="someItem">赠金<text class="bigFinger"> ¥{{ customer.zengAmount / 100 }}</text></div>
                        <div class="someItem">积分<text class="bigFinger"> {{ customer.point }}</text></div>
                    </div>
                </div>
                <div class="left" v-else>散客</div>
                <div class="right">

                </div>
            </div>
        </div>

        <div class="discountBar" v-if="chosedDiscountCard.cardName">
            <div class="leftPart" @click="doShowAllDiscountCard">
                {{ chosedDiscountCard.cardName }}
                <t-icon name="chevron-right" size="36rpx" />
            </div>
            <div class="rightPart">
                <t-checkbox :style="{ '--td-checkbox-bg-color': '#f2f3ff' }" v-model="useDiscountCard"
                    @change="doSwitchDiscard"></t-checkbox>
            </div>
        </div>

        <div class="productBox casherBox">
            <div class="title">消费项目</div>
            <div class="productList">
                <div class="cartProductBox" v-for="(item, index) in cartList" :key="item._id">
                    <div class="firstBar flexbar">
                        <div class="name">{{ item.name }}</div>
                        <div class="price">
                            单价:￥{{ item.price / 100 }}
                        </div>
                    </div>
                    <div class="secondBar flexbar">
                        <div class="title">{{ item.shl }}</div>
                        <div class="oprateBar">
                            <t-stepper :max="item.typeInfo === 'cika' ? 1 : 9999" v-model="item.shl" theme="filled"
                                @change="(value) => doCountChange(value, index)" />
                        </div>
                    </div>
                    <div class="secondBar flexbar">
                        <div class="title"></div>
                        <div v-if="item.ticheng && item.ticheng.length" @click="showService(index)"
                            class="oprateBar serviceBar">
                            {{ joinNames(item.ticheng) }}
                            <t-icon name="chevron-right" size="36rpx" />
                        </div>
                        <div v-else @click="showService(index)" class="oprateBar serviceBar">
                            服务人员
                            <t-icon name="chevron-right" size="36rpx" />
                        </div>
                    </div>
                    <div class="thirdBar priceSummary" v-if="item.sumPrice !== item.sumPrice2">
                        金额调整：{{ (item.sumPrice - item.sumPrice2) > 0 ? '' : '+' }}{{ (item.sumPrice - item.sumPrice2) /
                            100 * -1 }}
                    </div>
                    <div class="thirdBar priceSummary" v-if="item.typeInfo !== 'cika'" @click="doEditPrice(index)">
                        小计：￥{{ item.sumPrice2 / 100 }}
                        <t-icon name="edit" size="34rpx" style="margin-left:1vw" />
                    </div>
                    <div class="thirdBar priceSummary" v-else>
                        次卡抵扣
                    </div>
                </div>
            </div>

        </div>

        <t-cell v-if="orderForm.realPay > 0" title="付款方式" hover arrow @click="goChosePayType"
            :note="orderForm.payType.name" />
        <div class="spaceBar"></div>

        <div class="spaceBar"></div>
        <t-cell title="合计金额" hover :note="`￥${orderForm.totalPrice / 100}`" />
        <div class="spaceBar"></div>
        <t-cell title="折扣优惠" v-if="orderForm.discountAmount" :note="`-￥${orderForm.discountAmount / 100}`" />
        <div class="spaceBar"></div>
        <t-cell title="手动调整" v-if="orderForm.operateAmount<0" :note="`+￥${orderForm.operateAmount*-1 / 100}`" />

          <t-cell title="手动调整" v-if="orderForm.operateAmount>0" :note="`-￥${orderForm.operateAmount / 100}`" />
        <div class="spaceBar"></div>
        <t-cell title="次卡抵扣" v-if="orderForm.cikaAmountRaw" :note="`-￥${orderForm.cikaAmountRaw / 100}`" />
        <div class="spaceBar"></div>
        <t-cell title="优惠券" v-if="customer._id && !orderForm.coupon._id" hover arrow @click="goChoseCoupon">

            <template #note>
                {{ customer.sum.coupon }}张
            </template>
        </t-cell>
        <t-cell title="优惠券" v-if="orderForm.coupon._id" hover @click="clearCoupon">
            <template #note>
                -￥{{ orderForm.couponAmount / 100 }}
                <text class="closeBtn">X</text>
            </template>
        </t-cell>
        <div class="spaceBar"></div>

        <t-cell title="提成信息" hover arrow @click="goShowCommission" :note="`${orderForm.totalTiChengAmount / 100}`" />
        <div class="spaceBar"></div>
        <t-cell title="订单备注" hover arrow @click="showBeizDialog = true" :note="orderForm.beiz" />
    </div>

    <div class="confirmBar casherBox">
        <div class="left">
            <!-- <t-button type="default" :disabled="isSubmitLoading" @click="doSaveTempOrder" style="width:30vw;">
                挂单
            </t-button> -->
        </div>
        <div class="right">
            <t-button :disabled="isSubmitLoading" theme="primary" @click="doOrderSubmit">
                结算￥{{ orderForm.realPay / 100 }}
            </t-button>
        </div>
    </div>

    <!-- 提成信息对话框 -->
    <t-popup v-model:visible="showCommssionListDialog" placement="bottom" :height="0.8">
        <div class="dialog-content">
            <div class="dialog-header">
                <text>合计：{{ orderForm.totalTiChengAmount / 100 }}</text>
            </div>
            <scroll-div scroll-y class="dialog-body">
                <div v-for="(item, index) in cartList" :key="item._id">
                    <div v-if="item.ticheng && item.ticheng.length">
                        <t-cell-group :title="item.name">

                            <template v-for="(item2, index2) in item.ticheng" :key="index2">
                                <t-input :label="item2.name" type="number" :value="item2.tichengAmount / 100"
                                    placeholder="0" @onChange="(e) => onCommissionPriceInput(e, index, index2)" />
                            </template>

                        </t-cell-group>
                    </div>
                </div>
            </scroll-div>
            <div class="dialog-footer">
                <t-button theme="primary" @click="doCloseCommissionDialog">确定</t-button>
            </div>
        </div>
    </t-popup>

    <!-- 编辑价格对话框 -->
    <t-popup v-model:visible="showEditPriceDialog" placement="bottom" height="40vh">
        <div class="dialog-content">
            <div class="dialog-header">
                <text>原价：¥{{ editPriceData.sumPrice }}</text>
            </div>
            <div class="dialog-body">
                <!-- 这里需要替换为实际的编辑价格组件 -->
                <my-edit-price @onChange="handlePriceEdit" :index="editPriceData.index"
                    :discount="editPriceData.discount" :sumPrice="editPriceData.sumPrice"
                    :sumPrice2="editPriceData.sumPrice2" />
            </div>
        </div>
    </t-popup>

    <!-- 选择打折卡对话框 -->
    <t-popup v-model:visible="showDiscountCardListDialog" placement="bottom" :height="0.6">
        <div class="dialog-content">
            <div class="dialog-header">
                <text>选择打折卡</text>
            </div>

            <t-cell v-for="(item, index) in discountCardList" :key="item._id" style="height: 10vh;"
                @click="choseThisDsicountCard(index)" :title="item.cardName" :note="`${item.discount / 10}折`" arrow
                hover />

        </div>
    </t-popup>


    <t-popup v-model:visible="showServiceDialog" :destroyOnClose="true" placement="bottom" :height="0.7">
        <div class="dialog-content">
            <div class="dialog-header">
                <text>选择服务人</text>
            </div>

            <choseService @confirm="onServiceConfirm" :productItem="productItem"></choseService>

        </div>
    </t-popup>

    <t-popup v-model:visible="showBeizDialog" :destroyOnClose="true" placement="bottom" :height="0.7">
        <div class="dialog-content">
            <div class="dialog-header">
                <text>请输入备注</text>
            </div>
            <div class="dialog-body">

                <t-textarea v-model="orderForm.beiz" placeholder="请输入备注内容"></t-textarea>
            </div>
            <div class="dialog-footer">
                <t-button theme="primary" @click="showBeizDialog = false">确定</t-button>
            </div>
        </div>
    </t-popup>

    <t-popup v-model:visible="showCouponDialog" :destroyOnClose="true" placement="bottom" :height="0.7">
        <choseCoupon @closeDialog="showCouponDialog = false" :customerId="customer._id"
            :totalPrice="choseCouponForm.totalPrice" :solidProductPrice="choseCouponForm.solidProductPrice"
            :serviceProductPrice="choseCouponForm.serviceProductPrice" @useCoupon="onCouponConfirm"></choseCoupon>
    </t-popup>
    <t-action-sheet v-model="showActionSheet" :items="actionSheetItems" @selected="handlePayTypeSelected"
        @cancel="handleCancel" />
</template>

<script>
import { ref, onMounted, reactive, getCurrentInstance } from 'vue';
import { orderData, stateShop, stateUser,stateReloadCustomer } from '@/store.js';
import { useRouter } from 'vue-router';
import { Toast } from 'tdesign-mobile-vue';
import Decimal from 'decimal';
import { getTimeBag, formatTimeSN } from '@/utils.js';
import myEditPrice from '@/components/my-edit-price.vue';
import choseService from '@/components/chose-service.vue';
import choseCoupon from '@/components/chose-coupon.vue';
import navBack  from '@/components/nav-back-top.vue'
export default {
    name: 'ConfirmOrder',
    components: {
        myEditPrice,
        choseService,
        choseCoupon,
        navBack
    },
    setup() {
        const router = useRouter();
        const { proxy } = getCurrentInstance();
        const showServiceDialog = ref(false);
        const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
        const goBackClick = () => {
            router.back();
        }
        const orderForm = reactive({
            beiz: "",
            createAt: getTimeBag(),
            totalPrice: 0,
            totalshl: 0,
            totalPay: 0,
            sumPrice: 0,
            pointAmount: 0,
            couponAmount: 0,
            discountAmount: 0,
            coupon: {},
            costPoint: 0,
            usePoint: false,

            chosedDiscountCard: { cardName: "无" },
            useDiscountCard: false,
            shopName: stateShop.shopName,
            operator: stateUser,
            doSendMsg: false,
            realPay: 0,
            totalAmount: 0,
            actualPay: 0,
            tichengSummary: [],
            totalTiChengAmount: 0,
            payType: { value: "wepay", name: "微信" },
            discount: 100,
            orderNo: "",
            productList: [],
            shopId: stateShop._id,
            cikaAmount: 0,
            cikaAmountRaw: 0,
            operateAmount: 0,
            payWay: 'wepay',
            temp_order_id: "",
            yuyue_order_id: ''
        });

        // 数据定义
        const customer = reactive({
            _id: 0,
            name: '散客'
        });
        const customerType = ref(1);
        const price2PointOn = ref(false);
        const showCommssionListDialog = ref(false);

        const choseProductData = ref({});
        const couponList = ref([]);
        const tichengProductIndex = ref(0);

        const productItem = reactive({
            _id: '',
            name: ''
        });

        const showActionSheet = ref(false);
        const discountCardList = ref([]);
        const chosedDiscountCard = reactive({});
        const showDiscountCardListDialog = ref(false);


        const choseCouponForm = reactive({

            totalPrice: 0,
            solidProductPrice: 0,
            serviceProductPrice: 0
        });



        const actionSheetItems = ref([]);
        const editPriceData = reactive({
            index: 0,
            discount: 100,
            sumPrice: 0,
            sumPrice2: 0
        });

        // orderform中的内容




        const showCouponDialog = ref(false);
        const tichengSummary = ref([]);
        const showEditPriceDialog = ref(false);

        const payWay = ref('');


        const showBeizDialog = ref(false);
        const payTypes = ref([
            { name: '微信', value: 'wepay' },
            { name: '支付宝', value: 'alipay' },
            { name: '现金', value: 'cash' },
            { name: '本金', value: 'storeAmount' },
            { name: '赠金', value: 'zengAmount' }
        ]);

        const cartList = ref([]);

        // 工具函数
        const joinNames = (ticheng) => {
            if (ticheng) {
                return ticheng.map(item => item.name).join(',');
            }
            return '';
        };

        const onCouponConfirm = (coupon) => {
            console.log('coupon', coupon);
            orderForm.coupon = coupon;
            orderForm.couponAmount = coupon.couponAmount;
            orderForm.realPay = orderForm.sumPrice - coupon.couponAmount;
            orderForm.totalPay = orderForm.sumPrice - coupon.couponAmount + orderForm.cikaAmount;

            showCouponDialog.value = false;


        };

        const joinPayType = (payType) => {
            if (payType.length) {
                return payType.map(item => item.name).join(',');
            }
            return '';
        };

        // 方法定义
        const loadCustomerDiscountCard = async () => {
            const db = app.database();
            try {
                const res = await db.collection("my_customer_card").where({
                    'customer._id': customer._id,
                    status: 1,
                    type: 3
                }).get();

                if (res.data.length) {
                    discountCardList.value = res.data;
                    Object.assign(chosedDiscountCard, res.data[0]);
                }
            } catch (error) {
                console.error('加载客户折扣卡失败:', error);
            }
        };

        const onCommissionPriceInput = (value, index, index2) => {


            cartList.value[index].ticheng[index2].tichengAmount = Number(value) * 100;

            // 统计全部提成
            let total = 0;
            cartList.value.forEach(item => {
                if (item.ticheng) {
                    item.ticheng.forEach(item2 => {
                        total += Number(item2.tichengAmount);
                    });
                }
            });

            orderForm.totalTiChengAmount = total;
        };

        const showService = (index) => {

            const cartItem = cartList.value[index];
            cartItem.pay_type = orderForm.payType.name;

            tichengProductIndex.value = index;

            Object.keys(cartItem).forEach(key => {
                productItem[key] = cartItem[key];
            });
            showServiceDialog.value = true;
        };
        const onServiceConfirm = (res) => {
            showServiceDialog.value = false;
            let index = tichengProductIndex.value;
            console.log(index, cartList.value)
            cartList.value[index].ticheng = res;
            calculateTotalPriceAndCommission(true);
        };
        const doShowAllDiscountCard = () => {

            showDiscountCardListDialog.value = true;
        };

        const choseThisDsicountCard = (index) => {
            const chosedCard = discountCardList.value[index];
            const useDiscount = orderForm.useDiscountCard;
            const discountValue = useDiscount ? Number(orderForm.chosedDiscountCard.discount) : 100;

            orderForm.discount = discountValue;
            chosedDiscountCard.value = chosedCard;
            showDiscountCardListDialog.value = false;

            if (useDiscount) {
                clearCoupon();
                calculateEachProductSumPrice2();
                calculateTotalPriceAndCommission();
            }
        };

        const doSwitchDiscard = (checked) => {




            orderForm.useDiscountCard = checked;
            const discountValue = checked ? Number(chosedDiscountCard.discount) : 100;
            orderForm.discount = discountValue;

            cartList.value.forEach(item => {
                if (item.typeInfo == 'normal') {
                    const sumPrice2 = new Decimal(item.sumPrice).mul(discountValue).div(100).toNumber();
                    item.sumPrice2 = sumPrice2;
                    item.discountAmount = new Decimal(item.sumPrice).sub(item.sumPrice2).toNumber();
                    item.discountCardName = checked ? chosedDiscountCard.name : '无';
                    item.discount = discountValue;
                    item.operatePrice = 0;
                }
            });

            clearCoupon();
            calculateEachProductSumPrice2();
            calculateTotalPriceAndCommission();
        };

        const doCountChange = (value, index) => {

            console.log('数量变化', value, index);

            if (value == 0) {
                cartList.value.splice(index, 1);
            } else {
                cartList.value[index].shl = value;
                cartList.value[index].sumPrice = new Decimal(value).mul(cartList.value[index].price).toNumber();
                cartList.value[index].operatePrice = 0;
            }

            clearCoupon();
            calculateEachProductSumPrice2();
            calculateTotalPriceAndCommission(true);
        };



        const goShowNote = () => {
            // 显示备注输入框
            // 这里需要根据实际使用的UI库来实现
        };

        const goShowCommission = () => {
            showCommssionListDialog.value = true;
        };

        const goSearchCustomer = () => {
            router.push({
                path: './../choseCustomer2/index'
            });
        };

        const goChoseProduct = () => {
            router.goBack(-1);
        };

        const handlePayTypeSelected = (value, index) => {

            console.log(value, index, 234);

            orderForm.payType = payTypes.value[index];
            orderForm.payWay = payTypes.value[index].value;
        }
        const calculateEachProductSumPrice2 = () => {

            const discount = orderForm.discount;
            const chosedCard = orderForm.chosedDiscountCard;

            if (isNaN(discount)) {
                console.error('折扣不正确', discount);
                return;
            }

            cartList.value.forEach((item) => {
                if (isNaN(item.sumPrice)) {
                    return;
                }
                if (item.typeInfo == 'cika') return;
                if (item.operatePrice != 0) return;

                item.sumPrice2 = new Decimal(item.sumPrice).mul(discount).div(100).toNumber();
                item.discountAmount = new Decimal(item.sumPrice).sub(item.sumPrice2).toNumber();
                item.operatePrice = item.operatePrice ? item.operatePrice : 0;
                item.discountCardName = chosedCard.cardName;
                item.discountValue = discount;
            });
        };


        const calculateTotalPriceAndCommission = (doCalculatecommission = false) => {



            let cikaAmount = 0;
            let cikaAmountRaw = 0;
            let totalPrice = 0;
            let sumPrice = 0;
            let discountAmount = 0;
            let operateAmount = 0;
            let totalTicheng = 0;

            cartList.value.forEach(cartItem => {
                if (cartItem.ticheng && doCalculatecommission) {
                    for (const userItem of cartItem.ticheng) {
                        userItem.yejiAmount = new Decimal(userItem.yejiPercent).mul(cartItem.sumPrice2).toNumber();

                        if (userItem.commission) {
                            const { commissionType, commissionValue } = userItem.commission;
                            userItem.tichengAmount = commissionType == "A" ?
                                new Decimal(commissionValue).mul(cartItem.shl).mul(100).toNumber() :
                                new Decimal(cartItem.sumPrice2).mul(commissionValue).div(100).toNumber();
                            totalTicheng += Number(userItem.tichengAmount);
                        }
                    }
                }

                if (cartItem.typeInfo == "normal") {
                    cartItem.operatePrice = cartItem.operatePrice || 0;
                    cartItem.discountAmount = cartItem.discountAmount || 0;
                    sumPrice += Number(cartItem.sumPrice2);
                    discountAmount += Number(cartItem.discountAmount);
                    operateAmount += Number(cartItem.operatePrice);
                    cartItem.realPay = Number(cartItem.sumPrice2);
                    cartItem.payWay = payWay.value;
                } else if (cartItem.typeInfo == "cika") {
                    cikaAmount += Number(cartItem.realPay);
                    cikaAmountRaw += Number(cartItem.sumPrice);
                    cartItem.payWay = 'cika';
                }
                totalPrice += Number(cartItem.sumPrice);
            });



            orderForm.totalPrice = totalPrice;
            orderForm.sumPrice = sumPrice;
            orderForm.operateAmount = operateAmount;
            orderForm.totalTiChengAmount = totalTicheng;
            orderForm.cikaAmount = cikaAmount;
            orderForm.discountAmount = discountAmount;
            orderForm.cikaAmountRaw = cikaAmountRaw;
            orderForm.realPay = Decimal(sumPrice).sub(orderForm.couponAmount).toNumber();
            orderForm.totalPay = Decimal(cikaAmount).add(orderForm.realPay).toNumber();
        };

        const doOrderSubmit = async () => {


            const db = app.database();
            const createAt = getTimeBag();

            if (orderForm.payType.value == 'storeAmount') {
                if (customer.storeAmount < orderForm.realPay) {
                    Toast({ message: '余额不足', theme: 'error' });
                    return;
                }
            }

            if (orderForm.payType.value == 'zengAmount') {
                if (customer.zengAmount < orderForm.realPay) {
                    Toast({ message: '余额不足', theme: 'error' });
                    return;
                }
            }

            Toast({ message: '处理中', theme: 'loading' });

            if (cartList.value.length == 0) {
                Toast({ message: '商品不能为空', theme: 'error' });
                return;
            }

            if (!orderForm.payType.name && orderForm.realPay > 0) {
                Toast({ message: '请选择付款方式', theme: 'error' });
                return;
            }



            const orderCountRes = await db.collection("my_order").where({
                "createAt.time3": orderForm.createAt.time3,
                shopId: stateShop._id
            }).count();

            const orderCount = orderCountRes.total;
            let orderNo = formatTimeSN() * 10000 + orderCount + 1;
            orderNo = "XS" + orderNo;

            const postData = {
                customer: orderData.customer,
                payType: orderForm.payType.value,
                cartList: cartList.value,
                realPay: orderForm.realPay,
                cikaAmount: orderForm.cikaAmount,

                beiz: orderForm.beiz,
                createAt: orderForm.createAt,
                totalPrice: orderForm.totalPrice,
                totalshl: orderForm.totalshl,
                totalPay: orderForm.totalPay,
                sumPrice: orderForm.sumPrice,
                pointAmount: orderForm.pointAmount,
                couponAmount: orderForm.couponAmount,
                discountAmount: orderForm.discountAmount,
                coupon: orderForm.coupon,
                costPoint: orderForm.costPoint,
                usePoint: orderForm.usePoint,
                chosedDiscountCard: orderForm.chosedDiscountCard,
                useDiscountCard: orderForm.useDiscountCard,
                shopName: orderForm.shopName,
                operator: orderForm.operator,
                doSendMsg: orderForm.doSendMsg,
                totalAmount: orderForm.totalAmount,
                actualPay: orderForm.actualPay,
                tichengSummary: orderForm.tichengSummary,
                totalTiChengAmount: orderForm.totalTiChengAmount,
                discount: orderForm.discount,
                orderNo: orderForm.orderNo,
                productList: orderForm.productList,
                shopId: orderForm.shopId,
                cikaAmountRaw: orderForm.cikaAmountRaw,
                operateAmount: orderForm.operateAmount,
                payWay: orderForm.payWay,
                temp_order_id: orderForm.temp_order_id,
                yuyue_order_id: orderForm.yuyue_order_id
            };


            const tichengSummary = cartList.value.map(item => {
                return {
                    categoryId: item.categoryId,
                    productName: item.name,
                    payWay: item.payWay,
                    shl: item.shl,
                    productType: item.productType,
                    realPay: item.realPay,
                    _id: item._id,
                    typeInfo: item.typeInfo,
                    ticheng: item.ticheng
                };
            });

            postData['tichengSummary'] = tichengSummary;
            postData['createAt'] = createAt;
            postData['orderNo'] = orderNo;
            postData['productList'] = cartList.value;
            postData['shopId'] = stateShop._id;
            postData['operator'] = stateUser;
            let payType2 = [];
            if (orderForm.payType.value) {
                payType2.push({
                    ...orderForm.payType,
                    amount: orderForm.realPay
                });
            }
            if (orderForm.cikaAmount > 0) {
                payType2.push({
                    value: 'cika',
                    name: '次卡',
                    amount: orderForm.cikaAmount
                });
            }
            postData['payType'] = payType2;

            const res = await app.callFunction({
                name: 'my_confirm_order',
                data: {
                    op: 'casher',
                    ...postData
                }
            });

            if (res.result.status == 1) {
                Toast({ message: '保存成功' });
                stateReloadCustomer.value = true;
                setTimeout(() => {
                   router.push({ path: '/orderList' });
                }, 600);
            } else {

                Toast({ message: res.result.msg, theme: 'error' });
            }

        };


        const doEditPrice = (index) => {
            const cartListValue = cartList.value;
            const sumPrice2 = cartListValue[index].sumPrice2;
            const sumPrice = cartListValue[index].sumPrice;
            const discountValue = sumPrice ? new Decimal(sumPrice2).div(sumPrice).mul(10) : 0;

            const editData = {
                index,
                discount: discountValue,
                sumPrice: sumPrice / 100,
                sumPrice2: sumPrice2 / 100
            };

            editPriceData.index = editData.index;
            editPriceData.discount = editData.discount;
            editPriceData.sumPrice = editData.sumPrice;
            editPriceData.sumPrice2 = editData.sumPrice2;
            showEditPriceDialog.value = true;
        };

        const handlePriceEdit = (e) => {

            const { index, sumPrice2 } = e;
            const cartListValue = cartList.value;

            cartListValue[index].sumPrice2 = new Decimal(sumPrice2).mul(100).toNumber();
            cartListValue[index].discountValue = 10;
            cartListValue[index].discountAmount = 0;
            cartListValue[index].discountCardName = "无";
            cartListValue[index].operatePrice = new Decimal(cartListValue[index].sumPrice).sub(cartListValue[index].sumPrice2).toNumber();


            clearCoupon();
            calculateTotalPriceAndCommission(true);
            showEditPriceDialog.value = false;
        };

        const loadCustomerInfo = async () => {
            const customerId = customer._id;
            const db = app.database();

            try {
                const res = await db.collection("my_customer").doc(customerId).field({
                    _id: true,
                    name: true,
                    mobile: true,
                    storeAmount: true,
                    avatarUrl: true,
                    point: true,
                    zengAmount: true,
                    lastConsumAt: true,
                    totalConsumAmount: true,
                    sum: true
                }).get();

                if (res.data._id) {
                    customer.value = res.data;
                }
            } catch (error) {
                console.error('加载客户信息失败:', error);
            }

            loadCustomerDiscountCard();
        };

        const goChoseCoupon = () => {
            // 同时进行筛选和计算总价
            const [serviceProductList, solidProductList] = cartList.value.reduce(
                ([serviceProducts, solidProducts], item) => {
                    if (item.productType === 1) {
                        serviceProducts.push(item);
                    } else if (item.productType === 2) {
                        solidProducts.push(item);
                    }
                    return [serviceProducts, solidProducts];
                },
                [[], []]
            );

            // 计算服务和实体商品总价
            const serviceProductPrice = serviceProductList.reduce((sum, { sumPrice2 }) => sum + sumPrice2, 0);
            const solidProductPrice = solidProductList.reduce((sum, { sumPrice2 }) => sum + sumPrice2, 0);


            choseCouponForm.totalPrice = orderForm.sumPrice;
            choseCouponForm.solidProductPrice = solidProductPrice;
            choseCouponForm.serviceProductPrice = serviceProductPrice;

            showCouponDialog.value = true;
        };

        const clearCoupon = () => {
            orderForm.coupon = {};
            orderForm.couponAmount = 0;
            calculateTotalPriceAndCommission(false);
        };

        const doCloseCommissionDialog = () => {
            showCommssionListDialog.value = false;
        };

        const goChosePayType = () => {
            const payTypesValue = [...payTypes.value];



            if (customer._id == 0) {
                payTypesValue.splice(3);
            }

            const titles = payTypesValue.map(item => {
                let title = item.name;
                if (item.value == 'storeAmount') {
                    title += `(${customer.storeAmount / 100})`;
                }
                if (item.value == 'zengAmount') {
                    title += `(${customer.zengAmount / 100})`;
                }
                return title;
            });

            if (orderForm.realPay > 0) {

                actionSheetItems.value = titles;
                showActionSheet.value = true;
                // 显示付款方式选择弹窗
                // 根据使用的UI库实现
            }
        };

        // 生命周期
        onMounted(async () => {

            cartList.value = orderData.cartList;



            Object.keys(orderData.customer).forEach(key => {
                customer[key] = orderData.customer[key];
            });

            customerType.value = orderData.customerType;

            console.log(orderData, 'orderData')



            calculateTotalPriceAndCommission(true);


            loadCustomerDiscountCard();
            goChosePayType();
        });

        // 暴露给模板的数据和方法
        return {
            // 数据
            customer,
            customerType,
            price2PointOn,
            showCommssionListDialog,

            choseProductData,
            showActionSheet,
            actionSheetItems,
            couponList,
            orderForm,
            showCouponDialog,

            chosedDiscountCard,
            discountCardList,




            showDiscountCardListDialog,



            showServiceDialog,

            tichengSummary,
            showEditPriceDialog,

            payWay,
            onCouponConfirm,
            payTypes,
            cartList,
            handlePayTypeSelected,
            editPriceData,
            // 方法
            joinNames,
            joinPayType,
            loadCustomerDiscountCard,
            onCommissionPriceInput,
            doShowAllDiscountCard,
            choseThisDsicountCard,
            doSwitchDiscard,
            doCountChange,
            showService,
            productItem,
            goBackClick,
            goShowNote,
            goShowCommission,
            goSearchCustomer,
            goChoseProduct,
            calculateEachProductSumPrice2,
            calculateTotalPriceAndCommission,
            doOrderSubmit,
            onServiceConfirm,
            doEditPrice,
            showBeizDialog,
            handlePriceEdit,
            loadCustomerInfo,
            goChoseCoupon,
            clearCoupon,
            doCloseCommissionDialog,
            goChosePayType,
            choseCouponForm
        };
    }
};
</script>

<style scoped>
/* pages/casher/index.wxss */
.page {
    padding: 2vw 2vw;
    padding-bottom: 20vw;
}

.customerBar .left {
    font-weight: normal;
}

.discountBar {
    display: flex;
    justify-content: space-between;
    padding: 0vw 3vw;
    background-color: #f2f3ff;

}

.discountBar .leftPart {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.cartProductBox {
    border-bottom: 0.5px solid rgb(231, 231, 231);
    padding: 2vw;
    margin-bottom: 3vw;
}

radio {
    transform: scale(0.7);
    margin: 0;
}

.cartProductBox .firstBar {
    margin-bottom: 3vw;
}

.cartProductBox .firstBar .price {
    color: gray;
}

.customerBar .secondBar {
    margin-top: 3vw;
    margin-bottom: 3vw;
    display: flex;
}

.customerBar .secondBar .someItem {
    margin-right: 4vw;
    font-weight: normal;
    font-size: 0.9rem;
    color: gray;
}

.closeBtn {
    padding-left: 2vw;
}

.customerBar .secondBar .someItem .bigFinger {
    font-weight: bold;
    color: rgb(71, 71, 71);
}

.thirdBar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 3vw;
}

.priceSummary {
    color: gray;
    font-weight: 0.8rem;
}

.flexbar {
    display: flex;
    justify-content: space-between;
}

.casherBox {
    background-color: white;
    border-radius: 2vw;
    margin-bottom: 2vw;
    padding: 2vw 3vw;
}

.casherBox .title {
    color: gray;
    font-size: 0.8rem;
    margin-bottom: 2vw;
}

.customerBox .customerBar {
    display: flex;
    justify-content: space-between;
}

.someBtn {
    background-color: yellow;
}

.confirmBar {
    position: fixed;
    bottom: -5vw;
    width: 100vw;
    box-sizing: border-box;
    display: flex;
    height: 25vw;
    padding-top: 5vw;
    z-index: 4;
    justify-content: space-between;
}

.confirmBar .left {
    line-height: 10vw;
    height: 10vw;
}

.confirmBar .left .bigFont {
    font-size: 1.4rem;
}

.productBox .serviceBar {
    margin-top: 3vw;
    font-size: 1rem;
    color: gray;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.productBox .thirdBar {
    margin-top: 3vw;
    font-size: 0.8rem;

}

.productBox .name {
    font-size: 1rem;
}

.productBox .priceSummary {
    font-size: 1rem;
}

.actionBar {
    margin-top: 3vw;
    width: 100%;
    display: flex;

    justify-content: flex-end;

}

.spaceBar {

    margin-bottom: 2vw;
}

.dialog-content {
    padding: 5vw;
    box-sizing: border-box;
}

.dialog-header {
    text-align: center;
}

.dialog-footer {
    display: flex;
    justify-content: end;
}
</style>